'use client';

import React from 'react';
import { Control } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';

interface AcademicsStepProps {
  control: Control<any>;
  errors?: any;
  isEdit: boolean;
}

export default function AcademicsStep({ control }: AcademicsStepProps) {
  return (
    <div className="space-y-1">
      <FormField
        control={control}
        name="curriculum"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="xl:text-sm ml-1">Curriculum</FormLabel>
            <FormControl>
              <Textarea
                {...field}
                placeholder="Describe the curriculum offered"
                rows={4}
                className="max-w-full min-h-[80px] resize-none placeholder:text-muted-foreground placeholder:text-sm"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="specialties"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="xl:text-sm ml-1">Specialties</FormLabel>
            <FormControl>
              <Textarea
                {...field}
                placeholder=" STEM, music, outdoor play "
                rows={1}
                className="max-w-full min-h-[80px] resize-none placeholder:text-muted-foreground placeholder:text-sm"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="isReligious"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>Religious Institution</FormLabel>
            </div>
          </FormItem>
        )}
      />
    </div>
  );
}
